import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from 'classnames';
import { UXPContext } from '@core/context/Context';
/**
 *
 * This is a generic field used to layout forms. Typically used in conjunction with `<Label>` to show a field with a label
 * @export
 * @example
 * ```
 * <FormField inline>
 *       <Label>Button (active)</Label>
 *       <Button
 *           title="Sample Button"
 *           onClick={() => alert("clicked")}
 *           icon="https://static.iviva.com/images/Adani_UXP/QR_badge_icon.svg"
 *           active
 *       />
 *   </FormField>
 * ```
 *
 * @example
 * TODO: More Examples
 */
const FormField = (props) => {
    // props
    const context = React.useContext(UXPContext);
    const { inline, className, children, backgroundColor, style, noPadding, noMargin, marginBottomOnly } = props;
    let styles = Object.assign({}, style);
    if (backgroundColor)
        styles = Object.assign(Object.assign({}, styles), { backgroundColor: backgroundColor });
    return (_jsx("div", { className: classNames("uxpcore_form-field", className, {
            "uxpcore_form-field--inline": inline,
            "uxpcore_form-field--no-padding": noPadding,
            "uxpcore_form-field--no-margin": noMargin,
            "uxpcore_form-field--margin-bottom-only": marginBottomOnly
        }), style: styles, children: children }));
};
export default FormField;
